import { Component, Input, OnInit } from '@angular/core';
import { DragListCardSettings } from '@common-modules/shared/core/drag-list-card/drag-list-card-settings';
import { DragListCustomSettings } from '@common-modules/shared/core/drag-list-custom/drag-list-custom-settings';
import { asEnumerable } from 'linq-es2015';
import { LayerGroup, LayerItem } from '../../models/layer-item';

@Component({
    selector: 'wlm-layers-group-selector',
    templateUrl: './layers-group-selector.component.html',
    styleUrls: ['./layers-group-selector.component.scss'],
    host: { class: 'layers-group-selector' },
    standalone: false
})
export class LayersGroupSelectorComponent implements OnInit {
  private _layers: LayerItem[];
  public get layers(): LayerItem[] {
    return this._layers;
  }

  @Input() public set layers(value: LayerItem[]) {
    this._layers = value;
    if (value?.length) {
      this.groupLayersByNamespace(value);
    }
  }

  @Input() map;
  @Input() initialZIndex: number;
  @Input() showLayerTypeIcon: boolean;

  private _layerGroups: LayerGroup[];
  public get layerGroups(): LayerGroup[] {
    return this._layerGroups;
  }
  public set layerGroups(value: LayerGroup[]) {
    this._layerGroups = value;
    this.setLayerGroupPosition();
  }

  T_SCOPE = '';

  settingsCustom: DragListCustomSettings;
  cardSettings: DragListCardSettings;

  constructor() {}

  ngOnInit(): void {
    this.settingsCustom = new DragListCustomSettings({
      hideFilter: true,
      emptyLegendKey: this.T_SCOPE + '.messages.drag-list-empty-message',
      isReadOnly: false,
    });
  }

  setLayerGroupPosition() {
    this.layerGroups.forEach((group, i) => {
      group.position = this.layerGroups.length - i;
    });
  }

  groupLayersByNamespace(layers: LayerItem[]) {
    const groups = asEnumerable(layers)
      .GroupBy((x) => x.namespace)
      .ToDictionary(
        (x) => x.key,
        (x) => Array.from(x.values())
      );

    const layerGroups: LayerGroup[] = [];
    groups.forEach((value, key) => {
      const layerTitle = asEnumerable(value).FirstOrDefault()?.namespaceTitle ?? key;
      layerGroups.push(
        new LayerGroup({ namespace: key, layers: value, layerGroupTitle: layerTitle })
      );
    });

    this.layerGroups = layerGroups;
  }
}
